import { ErrorsService } from "src/app/services/common/errors.service";
import { MajorDegreeService } from "src/app/services/http/business/majorDegree/major-degree.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { SettingService } from "./../../../../services/http/business/setting/setting.service";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { FormBuilder, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatSelectChange,
  MatInput,
  MatSelect,
  MatDialogRef
} from "@angular/material";
import { FormGroup } from "@angular/forms";
import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import * as moment from "jalali-moment";

import { TranslateService } from "@ngstack/translate";
import { IContractType } from "src/app/interfaces/contractType";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { IRole } from "src/app/interfaces/role";
import { IBranch } from "src/app/interfaces/branch";
import { IMajorDegree } from "src/app/interfaces/majorDegree";
import { IContract } from "src/app/interfaces/contract";
import { SoundEnum } from "src/app/enums/sound.enum";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-contract-entry",
  templateUrl: "./contract-entry.component.html",
  styleUrls: ["./contract-entry.component.css"],
  providers: [ErrorsService]
})
export class ContractEntryComponent implements OnInit {
  roleList: IRole;
  form: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  branchList: IBranch;
  contractNumber: any;
  numbers: number[] = [];
  degreeList: IMajorDegree;
  btnDisable: boolean = false;
  contractType: IContractType;
  majorList: IMajorDegree[];
  minDate: any;

  @ViewChild("fromInput", { read: MatInput }) fromInput: MatInput;

  constructor(
    private fb: FormBuilder,
    private roleService: RoleService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private branchService: BranchService,
    private settingService: SettingService,
    private staticValue: StaticValueService,
    private majorService: MajorDegreeService,
    private contractService: ContractService,
    @Inject(MAT_DIALOG_DATA) public data: IContract,
    private dialogRef: MatDialogRef<ContractEntryComponent>
  ) { }

  ngOnInit() {
    this.getRoles();
    this.getMajor();
    this.createForm();
    this.fillNumber();
    this.setMindate();
    this.getBranchList();
    this.getContractType();
    this.setContractNumber();
    this.setDefaultInsurance();
  }

  createForm() {
    this.form = this.fb.group({
      FirstName: [""],
      LastName: [""],
      NationalCode: [
        this.data.NationalCode,
        Validators.compose([Validators.required,Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(12)])
      ],
      Gender: [this.data.Gender, Validators.compose([Validators.required])],
      PersonCode: [null, Validators.compose([Validators.maxLength(50)])],
      RoleId: [null, Validators.compose([Validators.required])],
      ContractNumber: [null],
      ContractTypeId: [this.data.ContractTypeId],
      HasTax: ["false"],
      HasInsurance: ["false"],
      InsuranceDayPerMonth: [0, Validators.compose([Validators.required])],
      ContractStartDate: [null, Validators.compose([Validators.required])],
      ContractEndDate: [null, Validators.compose([Validators.required])],
      ContractBranch: [],
      DegreeId: [null, Validators.compose([Validators.required])],
      MajorId: [null, Validators.compose([Validators.required])],
      ActivateCode: [this.data.ActivateCode],
      Id: [0],
      BranchEncryptId: [null],
      Description: [""],
      IsAsset: [false, Validators.compose([Validators.required])],
      IsSub: [false, Validators.compose([Validators.required])],
      CanPlacement: [false, Validators.compose([Validators.required])]
    });
  }
  getContractType() {
    this.staticValue.ContractType().subscribe(res => {
      this.contractType = res;
    });
  }

  fillNumber() {
    for (let i = 31; i >= 1; i--) {
      this.numbers.push(i);
    }
  }

  onChange(event: MatSelectChange) {
    if (event.value === "true") {
      this.form.controls["InsuranceDayPerMonth"].patchValue(null);
      this.btnDisable = false;
    } else {
      this.form.controls["InsuranceDayPerMonth"].patchValue(0);
      this.btnDisable = true;
    }
  }

  getRoles() {
    this.roleService.list().subscribe(
      res => {
        this.roleList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setContractNumber() {
    this.settingService.getIndicator().subscribe(
      res => {
        this.contractNumber = res.IndicatoNumber;
        this.form.controls["ContractNumber"].patchValue(res.IndicatoNumber);
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  reset() {
    this.fromInput.value = null;
    this.form.controls["LeavingJobDate"].setValue(null);
  }

  getBranchList() {
    this.branchService.list().subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getMajor() {
    this.majorService.list().subscribe(
      res => {
        this.degreeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadMajor(element: MatSelect) {
    this.majorService.degreeList(element.value).subscribe(
      res => {
        this.majorList = res.EduMajors;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setMindate() {
    this.settingService.getContractDate().subscribe(
      res => {
        this.minDate = moment.from(res.Date.toString(), "en");
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setDefaultInsurance() {
    this.form.controls["HasInsurance"].setValue(false);
  }

  getRoleId(id: number) {
    this.form.controls["RoleId"].patchValue(id);
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit(data: any) {
    this.errors = new Array();
    var brGuidList = data.BranchEncryptId;
    var convertArrtoObject = new Array();
    brGuidList.forEach(x => {
      convertArrtoObject.push({ BranchEncryptId: x });
    });
    this.form.controls["ContractBranch"].setValue(convertArrtoObject);
    this.form.value.ContractStartDate = moment
      .from(data.ContractStartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    this.form.value.ContractEndDate = moment
      .from(data.ContractEndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    this.contractService.add(this.form.value).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.onNoClick();
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
